import {FeedbackMode} from '@q9elements/ui-kit/common';

export const feedbackSelectOptions = [
  {
    label: 'CORE.COMMENTS.ACTIVE',
    value: FeedbackMode.opened
  },
  {
    label: 'CORE.COMMENTS.RESOLVED',
    value: FeedbackMode.resolved
  }
];
